import "./calendar-mob.component.scoped.sass";
import React, { useState, useEffect } from "react";
import { CalendarMobProps } from "src/types/calendar-props";
import MomentUtils from '@date-io/moment';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from "moment";
import "moment/locale/de";
import { LangService } from "src/services/lang/lang.service";
import TasksFilterDialog from "src/dialogs/tasks-filter-mob/tasks-filter-mob.component";

export const CalendarMobComponent = (props: CalendarMobProps) => {
  moment.locale("de");
  const { refresh } = props;
  const langService = new LangService();
  const locale = langService.getCurrentLang();
  const [selectedDate, setDate] = useState(moment());
  const [tasks, setTasks] = useState(props.data);
  const [openFilter, setOpenDialog] = React.useState(false);

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const openDialog = () => {
    setOpenDialog(true);
  }

  const handleDateChange = (date: any) => {
    props.onDateChange(date.format("YYYY-MM-DD"))
    setDate(date._d);
  }

  const handleMonthChange = (date: any) => {
    props.onMonthChange(date)
  }

  useEffect(() => {
    setTasks(props.data);
    // eslint-disable-next-line
  }, [props.data]);
  return (
    <div className="wrapper">
      <div className="calendar-wrapper">
        <img src={"/icons/filter-outline-blue.svg"} alt="" className="filter-ico" onClick={openDialog}/>
        <img src={"/icons/reload-blue.svg"} alt="" className="reload-ico" onClick={refresh}/>
        <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale={locale}>
          <DatePicker
            autoOk
            orientation="landscape"
            variant="static"
            openTo="date"
            value={selectedDate}
            onChange={handleDateChange}
            onMonthChange={handleMonthChange}
            renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
              const date: any = day?.format("YYYY-MM-DD");
              const isSelected = tasks && tasks[date] && tasks[date].tasks;
              return (
                <>
                  <div>{dayComponent}</div>
                  {isSelected && (<div className="badges">
                    {tasks[date].tasks.map((task: any, index: number) => (
                      (index < 5) && (<div className="day-badge" style={{background: task.color}} key={`${index}`}></div>)
                      ))}
                    </div>
                  )}
                </>
              );
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
      <TasksFilterDialog open={openFilter} onClose={handleDialogClose}/>
    </div>
  );
};
